<template>
  <div class="settings-wrapper">
    <page-header
      title="Settings"
      breadcrumbText="Dashboard >> Settings >> Roles & priviledges"
    />
    <div class="search-input-wrapper">
      <input type="text" class="search-input" placeholder="Search..." />
      <search-icon />
    </div>
    <settings-cards />
  </div>
</template>

<script>
import PageHeader from "@/components/UI/PageHeader";
import SettingsCards from "./partials/SettingsCardsWrapper";
export default {
  components: {
    PageHeader,
    SettingsCards,
  },
};
</script>

<style scoped>
.search-input-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #dfe3e2;
  height: 2.25rem;
  width: 30vw;
  border-radius: 15px;
  padding: 0 1rem;
  margin: 2rem 0;
}
.search-input {
  background: transparent;
  color: #343633;
  font-size: 0.9rem;
  width: 100%;
  height: 100%;
}
.search-input:focus {
  outline: none;
}
.search-input::placeholder {
  color: #343633;
  font-size: 0.9rem;
}
@media screen and (max-width: 768px) {
  .search-input-wrapper {
    width: 95vw;
  }
}
</style>
